import React, { useState } from 'react';
import { ReportViewModal } from './ReportViewModal';
import { ReportFormData } from '../types/survey';

// Test komponenta koja demonstrira korišćenje ReportViewModal
export const ReportViewTest: React.FC = () => {
	const [isModalOpen, setIsModalOpen] = useState(false);

	// Podaci iz vašeg primera
	const sampleReportData: ReportFormData = {
		name: 'Petar',
		surname: 'Obradovic',
		dateOfBirth: '2025-10-18',
		address: 'sdfsdfs',
		country: 'Albanija',
		contact: 'sdfsdf',
		gender: 'Transrodna osoba',
		maritalStatus: 'Udovac/ca',
		stayingWithType: 'Sa decom',
		placeWhereLives: 'U migrantskom centru',
		locationAddress: '',
		specialStatus: 'Izbeglo lice',
		healthStatus: 'Lake telesne povrede',
		exploitationType: 'Prinuda na vršenje krivičnih dela',
		exploitationPhase: 'Faza eksploatacije u toku',
		explanation: 'sdfsdfs',
		neededSupport: 'Pomoć u nabavci lekova i medicinskih sredstava',
		neededSupportDetails: 'dfgdfg',
		givenSupport: 'Smeštaj',
		givenSupportDetails: 'dfdfg',
		additionalNotes: '',
	};

	return (
		<div style={{ padding: '20px' }}>
			<h2>Test Pregled Prijave</h2>
			<button
				onClick={() => setIsModalOpen(true)}
				style={{
					padding: '10px 20px',
					backgroundColor: '#007bff',
					color: 'white',
					border: 'none',
					borderRadius: '5px',
					cursor: 'pointer',
				}}
			>
				Otvori pregled prijave
			</button>

			<ReportViewModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} reportData={sampleReportData} surveyId='survey-123' riskScore={85} timestamp='2025-10-02T14:30:00Z' />
		</div>
	);
};
